import React, {useCallback} from 'react';

import {Box, Link, Typography} from '@mui/material';

import {LINKS} from '@/constants/LinksConstants';
import {WEB_VIEW_MESSAGES} from '@/services/webview/constants';
import {WebViewService} from '@/services/webview/WebViewService';

const PrivacyPolicy: React.FC = () => {
  const handleLinkClick = useCallback(() => {
    if (
      WebViewService.isWebViewActive() &&
      typeof window.ReactNativeWebView !== 'undefined' &&
      window.ReactNativeWebView
    ) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({status: WEB_VIEW_MESSAGES.OPEN_PRIVACY_POLICY}),
      );
      return;
    }

    window.open(LINKS.PRIVACY_POLICY, '_blank', 'noopener,noreferrer');
  }, []);
  return (
    <Box
      className="privacy-policy"
      sx={{marginTop: '16px'}}>
      <Typography variant="body2">
        Modak data collection practices for kids can be found in its{' '}
        <Link
          sx={{
            cursor: 'pointer',
          }}
          onClick={handleLinkClick}
          className="text-link">
          privacy policy
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
